import { Properties } from '../../common';
import { abbreviateAmount, Abbreviation } from './priceFormatUtils';
import { IntlContextWithDictionary, numberI18n, NumberI18n } from '../types';
import { isNotPresent } from '../../utils';

export interface PointsProps extends Properties {
  totalPoints: number | string;
  showSuffix?: boolean;
  abbreviate?: boolean;
}

const ABBR_SETTINGS: { [digits: number]: Abbreviation } = {
  5: {
    divider: 1000,
    decimals: 0,
  },
  6: {
    divider: 1000,
    decimals: 0,
  },
  7: {
    divider: 1000000,
    decimals: 2,
  },
};

export const formatPoints = (
  totalPoints: number | string,
  abbreviate?: boolean,
  context?: IntlContextWithDictionary
): string => {
  const totalUserPoints = `${totalPoints}`;

  if (isNotPresent(totalUserPoints)) {
    return undefined;
  }

  const { millionAbbreviation, thousandAbbreviation, thousandSeparator, decimalSeparator }: NumberI18n =
    numberI18n(context);

  const getAbbreviateAmount = (): string => {
    const abbr: string = totalUserPoints.length < 7 ? thousandAbbreviation : millionAbbreviation;
    const { value } = abbreviateAmount(totalUserPoints, thousandAbbreviation, millionAbbreviation, {
      settings: ABBR_SETTINGS,
      symbol: abbr,
    });
    return value;
  };

  const formattedPoints: string = abbreviate
    ? getAbbreviateAmount()
    : totalUserPoints.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`).replace('.', decimalSeparator);
  return formattedPoints;
};
